// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC70Zmj4L11O6OXe1f7LjzKvNNx3G4Ye8A",
  authDomain: "wedding-invitation-fah.firebaseapp.com",
  projectId: "wedding-invitation-fah",
  storageBucket: "wedding-invitation-fah.appspot.com",
  messagingSenderId: "141247780526",
  appId: "1:141247780526:web:7fea27ce7da9adf09b3f3f",
  measurementId: "G-9T2EGB2JY0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default {
    app,
    analytics,
    db
};
